module.exports = __webpack_public_path__ + "static/media/letterpress.962d1583.jpg";